import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["onChange"];
import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import SC from './styles';
var StatefulMaskedInput = function StatefulMaskedInput(_ref) {
  var _onChange = _ref.onChange,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(props.value),
    value = _useState[0],
    setValue = _useState[1];
  return /*#__PURE__*/React.createElement(MaskedInput, {
    value: props.value || value,
    onChange: function onChange(e) {
      setValue(e.target.value);
      return _onChange && _onChange(e, _unmask(e.target.value));
    },
    guide: false,
    mask: createNumberMask(),
    render: function render(ref, inputProps) {
      return /*#__PURE__*/React.createElement(SC.Input, Object.assign({}, props, inputProps, {
        ref: ref
      }));
    }
  });
};
export default StatefulMaskedInput;
export var _unmask = function _unmask(value) {
  return value.replace(/\W+/g, '');
};